// extracted by mini-css-extract-plugin
export default {"modalBackground":"T_plBTjpsPz3ssEL0HDW"};